/**
 * Drop `undefined` keys from a partial wire payload before sending. Use as the
 * trailing `.transform(stripUndefined)` on entity -> API schemas so the API
 * body only carries fields the caller actually set.
 */
export function stripUndefined(value) {
    const out = {};
    for (const [key, entry] of Object.entries(value)) {
        if (entry !== undefined)
            out[key] = entry;
    }
    return out;
}
//# sourceMappingURL=objects.js.map